import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "@/components/ui/sidebar";
import { ActivityIcon, HistoryIcon, LayersIcon } from "lucide-react";
import { useUser } from "@clerk/react";
import { Link, useLocation } from "react-router-dom";
import { NavUser } from "./nav-user";
import { ScopeWrapper } from "@/components/ui/scope-wrapper";
import { useRadiusPreset } from "@/hooks/use-radius-preset";

// Staff-only pages under /manager (the route itself checks uplodio_member).
const MANAGER_ROWS = [
  { path: "/manager/success", label: "Success", icon: ActivityIcon },
  { path: "/manager/batch-status", label: "Batch status", icon: LayersIcon },
  { path: "/manager/activity", label: "Activity", icon: HistoryIcon },
];

/** Sidebar of the staff /manager area — same frame as AppSidebar, its own menu. */
export function ManagerSidebar() {
  const { user } = useUser();
  const location = useLocation();
  const radius = useRadiusPreset();

  return (
    <Sidebar collapsible="icon" variant={radius === "full" ? "inset" : "sidebar"}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link to="/manager">
                <div className="flex aspect-square size-8 shrink-0 items-center justify-center rounded-md border bg-muted-foreground/10">
                  <img
                    src="https://imagedelivery.net/6SRmze-FT2n2PI_eCsJRmg/b0fd555d-c987-4959-56d8-dead0b49dc00/public"
                    className="size-5"
                    alt=""
                  />
                </div>
                <div className="flex flex-col items-start justify-center truncate">
                  <span className="text-sm font-medium">Manager</span>
                  <span className="text-xs text-muted-foreground">Uplodio staff</span>
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent className="overflow-x-hidden">
        <SidebarGroup>
          <SidebarGroupLabel>Main Menu</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {MANAGER_ROWS.map(({ path, label, icon: Icon }) => (
                <SidebarMenuItem key={path}>
                  <SidebarMenuButton
                    asChild
                    isActive={location.pathname.startsWith(path)}
                    tooltip={label}
                  >
                    <Link to={path}>
                      <Icon />
                      <span>{label}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter>
        <ScopeWrapper>
          <NavUser
            user={{
              name: `${user?.firstName} ${user?.lastName}`,
              email: `${user?.primaryEmailAddress?.emailAddress}`,
              avatar: `${user?.imageUrl}`,
            }}
          />
        </ScopeWrapper>
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
